import React from 'react';
import PropTypes from 'prop-types';

MobileIconButton.propTypes = {
    onClick: PropTypes.func,
    color: PropTypes.string,
    children: PropTypes.node
};

function MobileIconButton({onClick, color = '#f5f5f5', children}) {
    return (
        <div
            onClick={onClick}
            style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '48px',
                height: '48px',
                borderRadius: '8px',
                backgroundColor: color,
                flexShrink: 0
            }}
        >
            {children}
        </div>
    );
}

export default MobileIconButton;
